import { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { AppState } from 'interface/stateApp';
import { AUTH_TYPE } from 'config/interfaces';
import Login from './Login';

interface AuthFormProps {
  stateApp: AppState;
  setStateApp: React.Dispatch<React.SetStateAction<AppState>>;
  isModalType?: boolean;
  onData?: any;
}

export default function AuthForm({ stateApp, setStateApp}: AuthFormProps) {
  const [action, setAction] = useState(AUTH_TYPE.LOGIN);
  const { showLoginForm, showRegisterForm } = stateApp;

  const handleButtonBackToLoginClick = (e: any) => {
    e.preventDefault();
    setAction(AUTH_TYPE.LOGIN);
  };

  useEffect(() => {
    if (showLoginForm) {
      setAction(AUTH_TYPE.LOGIN);
    }
    if (showRegisterForm) {
      setAction(AUTH_TYPE.REGISTER);
    }
  }, [showLoginForm, showRegisterForm]);

  return (
    <Modal
      open={showLoginForm || showRegisterForm}
      onCancel={() =>
        setStateApp({
          ...stateApp,
          showLoginForm: false,
          showRegisterForm: false,
        })}
        footer={[]}
        className="mx-auto w-full md:!w-[600px] rounded-full login-modal"
      >
        <div className='p-[60px]'>
          {action === AUTH_TYPE.LOGIN && (
            <Login
              stateApp={stateApp}
              setStateApp={setStateApp}
            />
          )}
        </div>

      </Modal>
    );
}
